import { connect } from 'react-redux';
import { appActions } from '../../../../app/app.actions';
import RakutenServices from './RakutenServices';
import { rakutenServicesActions } from './rakutenServices.actions';

function mapStateToProps(state) {
    return {
        services: state.rakutenServices.services,
        servicesConfig: state.rakutenServices.servicesConfig,
        gettingALinksAndNLStatus: state.rakutenServices.gettingALinksAndNLStatus,
        loadingServicesConfig: state.rakutenServices.loadingServicesConfig,
        loadingServicesConfigError: state.rakutenServices.loadingServicesConfigError,
        clientConfig: state.app.clientConfig,
        memberLoggedIn: state.app.memberLoggedIn,
        member: state.member,
        localeSet: state.app.locale,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadServicesConfig: () => {
            dispatch(rakutenServicesActions.loadServicesConfig());
        },
        updateNewsletterStatus: (serviceId) => {
            dispatch(rakutenServicesActions.updateNewsletterStatus(serviceId));
        },
        deleteAccount: (member, password) => {
            dispatch(rakutenServicesActions.cancelMembership(member, password));
        },
        getAgreementsLinksAndNewsletterStatus: () => {
            dispatch(rakutenServicesActions.getAgreementsLinksAndNewsletterStatus());
        },
        startDeleteAccount: () => {
            dispatch(rakutenServicesActions.startDeleteAccount());
        },
        trackExternalLink: (name) => {
            dispatch(appActions.trackExternalLinkClick(name));
        },
        trackAgreementClick: (data) => {
            dispatch(appActions.trackAgreement(data));
        },
    };
}

const RakutenServicesContainer = connect(mapStateToProps, mapDispatchToProps)(RakutenServices);

export default RakutenServicesContainer;
